export default "__VITE_ASSET__9c5a71e7__"